import React, {useContext} from 'react';
import {AccountFieldsFragment, Maybe} from '../api/generated';

export const AccountContext = React.createContext<Maybe<AccountFieldsFragment>>(null);

export const useAccountContext = () => useContext(AccountContext);
